import { BASIC_NODE_CONFIG, BASIC_NODE_CONFIG_SIZE } from 'src/utils/basic'
import type { MessageActionNodeType } from '../types'

export function generateMessageActionNodeConfig(id: string): MessageActionNodeType {
  return {
    ...BASIC_NODE_CONFIG,
    id,
    type: 'MessageAction',
    data: {
      ...BASIC_NODE_CONFIG_SIZE,
      nodeName: '消息节点',
      nodeType: 'MessageAction',
      nodeData: {},
      nodeStyle: {},
      nodeId: '',
      hasErr: false,
      errInfo: [],
    },
    position: {
      x: 0,
      y: 0,
    },
  }
}
